export type EvolutionProposal = {
  id: string;
  type: string;
  title: string;
  description: string | null;
  rationale: string | null;
  schema_diff?: Record<string, any> | null;
  status: string;
  created_at: string;
  applied_at: string | null;
};

type EvolutionProposalQuery = {
  workspaceId: string;
  statuses?: string[];
  type?: string;
};

export async function fetchEvolutionProposals({
  workspaceId,
  statuses,
  type,
}: EvolutionProposalQuery): Promise<EvolutionProposal[]> {
  const params = new URLSearchParams();
  params.set("workspace_id", workspaceId);
  if (statuses && statuses.length > 0) params.set("statuses", statuses.join(","));
  if (type) params.set("type", type);

  const res = await fetch(`/api/evolution/proposals?${params.toString()}`, {
    credentials: "include",
  });
  const json = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(json?.error || `HTTP ${res.status}`);
  }
  return Array.isArray(json?.proposals) ? (json.proposals as EvolutionProposal[]) : [];
}
